'use strict';

(function () {
  angular
    .module('specsguardApp')
    .controller('SettingsCtrl', SettingsCtrl);

  SettingsCtrl.$inject = ['$scope', 'User', 'Auth', 'Labels'];

  function SettingsCtrl ($scope, User, Auth, Labels) {
    $scope.errors = {};
    $scope.LABELS = Labels;

    $scope.changePassword = function (form) {
      $scope.submitted = true;
      if (form.$valid) {
        Auth.changePassword($scope.user.oldPassword, $scope.user.newPassword)
          .then(function () {
            $scope.message = $scope.LABELS.getLabel('changedpassword');
            Auth.logout();
          })
          .catch(function () {
            form.password.$setValidity('mongoose', false);
            $scope.errors.other = $scope.LABELS.getLabel('incorrectpassword');
            $scope.message = '';
          });
      }
    };
  }

})();
